export const BRANCH_CODE_TO_NAME = {
  B001: "MUMBAI",
  B002: "KOLKATA",
  B003: "DELHI",
  B004: "CHENNAI",
  B010: "LUCKNOW",
};

export const CLUSTER_CODE_TO_NAME = {
  CL01: "TAMIL NADU",
  CL02: "KARNATAKA",
  CL03: "ANDHRA PRADESH",
  CL04: "GUJARAT",
  CL05: "MUMBAI-PUNE",
  CL06: "GREATER MAHARASHTRA",
  CL07: "DELHI-GREATER DELHI",
  CL08: "PUNJAB-HARYANA-HILLS",
  CL09: "WEST BENGAL",
  CL10: "ORISSA-JHARKHAND",
  CL11: "NESA",
  CL12: "UTTAR PRADESH",
  CL13: "BIHAR",
  CL14: "MP-CHG",
  CL15: "KERALA",
  CL16: "RAJASTHAN",
};

export const CLUSTER_BRANCH_MAPPING = [
  {
    clustername: "ARUNACHAL PRADESH",
    clustercode: "CL11",
    branchname: "KOLKATA",
    branchcode: "B002"
  },
  {
    clustername: "HIMACHAL PRADESH",
    clustercode: "CL08",
    branchname: "DELHI",
    branchcode: "B003"
  },
  {
    clustername: "JAMMU & KASHMIR",
    clustercode: "CL08",
    branchname: "DELHI",
    branchcode: "B003"
  },
  {
    clustername: "MADHYA PRADESH",
    clustercode: "CL14",
    branchname: "LUCKNOW",
    branchcode: "B010"
  },
  {
    clustername: "ASSAM",
    clustercode: "CL11",
    branchname: "KOLKATA",
    branchcode: "B002"
  },
  {
    clustername: "CHHATTISGARH",
    clustercode: "CL14",
    branchname: "LUCKNOW",
    branchcode: "B010"
  },
  {
    clustername: "DELHI",
    clustercode: "CL07",
    branchname: "DELHI",
    branchcode: "B003"
  },
  {
    clustername: "GOA",
    clustercode: "CL06",
    branchname: "MUMBAI",
    branchcode: "B001"
  },
  {
    clustername: "HARYANA",
    clustercode: "CL08",
    branchname: "DELHI",
    branchcode: "B003"
  },
  {
    clustername: "JHARKHAND",
    clustercode: "CL10",
    branchname: "KOLKATA",
    branchcode: "B002"
  },
  {
    clustername: "LADAKH",
    clustercode: "CL08",
    branchname: "DELHI",
    branchcode: "B003"
  },
  {
    clustername: "MAHARASHTRA",
    clustercode: "CL05+CL06",
    branchname: "MUMBAI",
    branchcode: "B001"
  },
  {
    clustername: "MANIPUR",
    clustercode: "CL11",
    branchname: "KOLKATA",
    branchcode: "B002"
  },
  {
    clustername: "MEGHALAYA",
    clustercode: "CL11",
    branchname: "KOLKATA",
    branchcode: "B002"
  },
  {
    clustername: "MIZORAM",
    clustercode: "CL11",
    branchname: "KOLKATA",
    branchcode: "B002"
  },
  {
    clustername: "NAGALAND",
    clustercode: "CL11",
    branchname: "KOLKATA",
    branchcode: "B002"
  },
  {
    clustername: "ODISHA",
    clustercode: "CL10",
    branchname: "KOLKATA",
    branchcode: "B002"
  },
  {
    clustername: "SIKKIM",
    clustercode: "CL11",
    branchname: "KOLKATA",
    branchcode: "B002"
  },
  {
    clustername: "TELANGANA",
    clustercode: "CL03",
    branchname: "CHENNAI",
    branchcode: "B004"
  },
  {
    clustername: "TRIPURA",
    clustercode: "CL11",
    branchname: "KOLKATA",
    branchcode: "B002"
  },
  {
    clustername: "UTTARAKHAND",
    clustercode: "CL08",
    branchname: "DELHI",
    branchcode: "B003"
  },
  {
    clustername: "PUNJAB",
    clustercode: "CL08",
    branchname: "DELHI",
    branchcode: "B003"
  }
]
